"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSmartSubscriptionOptionsFunction = void 0;
function createSmartSubscriptionOptionsFunction(query, onError) {
    return (options = {}) => {
        var _a;
        const defaultErrorHandlerFn = (error, vm, key, type, options) => {
            onError(error, vm, {
                queryKey: key,
                queryType: type,
                queryOptions: options,
            });
        };
        return {
            query,
            ...options,
            error: ((_a = options.error) !== null && _a !== void 0 ? _a : onError !== undefined)
                ? defaultErrorHandlerFn
                : undefined,
        };
    };
}
exports.createSmartSubscriptionOptionsFunction = createSmartSubscriptionOptionsFunction;
//# sourceMappingURL=subscription.js.map